import { render, staticRenderFns } from "./proceso_recepcionar.vue?vue&type=template&id=ac844560&"
import script from "./proceso_recepcionar.vue?vue&type=script&lang=ts&"
export * from "./proceso_recepcionar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
